import api from '@/helpers/api'

const API_NEWSLETTER = `/api/newsletter`

export default {
    namespaced: true,
    state: {
        status: '',
        newsletters: [],
        currentNewsletter: null,
        tiers: [],
        errMessage: '',
        meta: {
            page: 1,
            limit: 10,
            total: 0
        }
    },
    mutations: {
        request(state) {
            state.status = 'loading'
        },
        success(state) {
            state.status = 'success'
        },
        error(state, { message }) {
            state.status = 'error'
            state.errMessage = message
        },
        setNewsletters(state, newsletters) {
            state.newsletters = newsletters
        },
        setCurrentNewsletter(state, newsletter) {
            state.currentNewsletter = newsletter
        },
        setTiers(state, tiers) {
            state.tiers = tiers
        },
        setMeta(state, meta) {
            state.meta = meta
        },
        clearCurrentNewsletter(state) {
            state.currentNewsletter = null
        }
    },
    actions: {
        /**
         * Fetch all newsletters for current corporate
         */
        read({ commit }, params = {}) {
            commit('request')
            return new Promise((resolve, reject) => {
                api.request('get', API_NEWSLETTER, params)
                    .then((result) => {
                        commit('success')
                        if (result.data.data && result.data.data.data && result.data.data.meta) {
                            commit('setNewsletters', result.data.data.data)
                            commit('setMeta', result.data.data.meta)
                        } else {
                            commit('setNewsletters', result.data.data)
                            if (result.data.meta) {
                                commit('setMeta', result.data.meta)
                            }
                        }

                        return resolve(result.data)
                    })
                    .catch((err) => {
                        commit('error', { message: err })
                        return reject(err)
                    })
            })
        },

        /**
         * Fetch single newsletter by ID
         */
        readSingle({ commit }, id) {
            commit('request')
            return new Promise((resolve, reject) => {
                api.request('get', `${API_NEWSLETTER}/${id}`)
                    .then((result) => {
                        commit('success')
                        commit('setCurrentNewsletter', result.data.data)
                        return resolve(result.data.data)
                    })
                    .catch((err) => {
                        commit('error', { message: err })
                        return reject(err)
                    })
            })
        },

        /**
         * Fetch available tiers for newsletter targeting
         */
        readTiers({ commit }) {
            commit('request')
            return new Promise((resolve, reject) => {
                api.request('get', `${API_NEWSLETTER}/tiers`)
                    .then((result) => {
                        commit('success')
                        commit('setTiers', result.data.data)
                        return resolve(result.data.data)
                    })
                    .catch((err) => {
                        commit('error', { message: err })
                        return reject(err)
                    })
            })
        },

        /**
         * Create new newsletter
         */
        create({ commit }, data) {
            commit('request')
            return new Promise((resolve, reject) => {
                api.request('post', API_NEWSLETTER, {}, data, {
                    headers: { 'Content-Type': 'multipart/form-data' }
                })
                    .then((result) => {
                        commit('success')
                        commit('setCurrentNewsletter', result.data.data)
                        return resolve(result.data)
                    })
                    .catch((err) => {
                        commit('error', { message: err })
                        return reject(err)
                    })
            })
        },

        /**
         * Update existing newsletter
         */
        update({ commit }, { id, data }) {
            commit('request')
            return new Promise((resolve, reject) => {
                api.request('post', `${API_NEWSLETTER}/${id}`, {}, data, {
                    headers: { 'Content-Type': 'multipart/form-data' }
                })
                    .then((result) => {
                        commit('success')
                        commit('setCurrentNewsletter', result.data.data)
                        return resolve(result.data)
                    })
                    .catch((err) => {
                        commit('error', { message: err })
                        return reject(err)
                    })
            })
        },

        /**
         * Delete newsletter
         */
        delete({ commit }, id) {
            commit('request')
            return new Promise((resolve, reject) => {
                api.request('delete', `${API_NEWSLETTER}/${id}`)
                    .then((result) => {
                        commit('success')
                        commit('clearCurrentNewsletter')
                        return resolve(result.data)
                    })
                    .catch((err) => {
                        commit('error', { message: err })
                        return reject(err)
                    })
            })
        },

        /**
         * Publish newsletter
         */
        publish({ commit }, id) {
            commit('request')
            return new Promise((resolve, reject) => {
                api.request('put', `${API_NEWSLETTER}/${id}/publish`)
                    .then((result) => {
                        commit('success')
                        commit('setCurrentNewsletter', result.data.data)
                        return resolve(result.data)
                    })
                    .catch((err) => {
                        commit('error', { message: err })
                        return reject(err)
                    })
            })
        }
    },
    getters: {
        isLoading: (state) => state.status === 'loading',
        newsletters: (state) => state.newsletters,
        currentNewsletter: (state) => state.currentNewsletter,
        tiers: (state) => state.tiers,
        meta: (state) => state.meta
    }
}
